import { CustomFieldType } from './types';

export type StringEqualityOptions = {
  caseSensitive?: boolean;
  trim?: boolean;
};

/** Per-CustomFieldType options accepted by `CustomFieldDefinition#equals`. */
export type EqualityOptionsByType = {
  text: StringEqualityOptions;
  textarea: StringEqualityOptions;
  email: StringEqualityOptions;
  url: never;
  number: never;
  boolean: never;
  select: never;
  duration: never;
  upload: never;
  'multi-upload': never;
  fieldset: never;
  user: never;
};

// Compile-time exhaustiveness: adding a CustomFieldType without a matching
// entry in EqualityOptionsByType produces a string-typed `_AssertNoMissing`,
// which `true` cannot be assigned to.
type _Missing = Exclude<CustomFieldType, keyof EqualityOptionsByType>;
type _AssertNoMissing = [_Missing] extends [never]
  ? true
  : `Add an entry to EqualityOptionsByType for CustomFieldType: '${_Missing}'`;
const _assertNoMissing: _AssertNoMissing = true;
void _assertNoMissing;

const STRING_EQUALITY_DEFAULTS: Required<StringEqualityOptions> = {
  caseSensitive: true,
  trim: false,
};

/** `null` matches only `null` — never `""`. */
export function stringEquals(
  a: string | null,
  b: string | null,
  options?: StringEqualityOptions
): boolean {
  if (a === null || b === null) return a === b;

  const { caseSensitive, trim } = { ...STRING_EQUALITY_DEFAULTS, ...options };

  let left = a;
  let right = b;
  if (trim) {
    left = left.trim();
    right = right.trim();
  }
  if (!caseSensitive) {
    left = left.toLowerCase();
    right = right.toLowerCase();
  }
  return left === right;
}
